import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import _style from './MenuItem.scss';
import { Popover, Tooltip } from 'antd';
import { CS_STYLES } from 'utils/constants/style-constants';
import Arrow from 'svg/v2/newcs_dashboard_left_arrow.svg';
import containerStyle from './CrashSightLeftMenu.scss';
import { useHover } from 'ahooks';
import { ze } from 'utils/zhEn';

export const MenuItem = ({
  showCollapsed, menuOption, pathname, search, selectedState,
  getMenuItemClassName, handleScrollToTop
}) => {

  const {children = [], pathPrefixes = [], disabled = false} = menuOption;

  const initialState = pathPrefixes.some((prefix) => pathname.includes(prefix));

  // 可展开父节点专用 class：仅用 menuItem + parentMenuSelected（不带 parentMenu），
  // 布局通过 inline style 强制控制，避免 parentMenu 的 margin-left:16px 影响左边距。
  const parentMenuClassName = children.length
    ? `${containerStyle.menuItem}${initialState ? ' ' + containerStyle.parentMenuSelected : ''}`
    : null;
  const [hoverKey, setHoverKey] = useState('');
  const [isShowChildren, setIsShowChildren] = useState(initialState);

  const ref = useRef(null);
  // const isHovering = useHover(ref);

  const svgIcon = ((initialState || menuOption.label === hoverKey) && menuOption.svgSelect) ? menuOption.svgSelect : menuOption.svg;
  function getChildLabel() {
    let label = menuOption.labelAbridge
    if (children.length) {
      // 选中子集展示子集的 label；共用 pathPrefix 时必须走 isActive（看 search）
      const childItem = children.find(childrenItem => isItemActive(childrenItem));
      if (childItem) {
        label = childItem.labelAbridge;
      }
    }
    return <div style={{fontSize: '12px',textAlign:'center', lineHeight: '12px', marginTop: '3px'}}>
      { label }
    </div>;
  }
  // 菜单item内部
  const inner = showCollapsed
    ? <div
      className={containerStyle.collapsedMenuItemWrapper}
      onMouseEnter={() => {
        setHoverKey(menuOption.label)
      }}
      onMouseLeave={() => {
        setHoverKey('')
      }}
    >
        <div
          style={{display: 'grid',placeItems: 'center'}}
        >{ svgIcon }</div>
        {getChildLabel()}
      </div>
    : <div className={containerStyle.menuItemWrapper}
        style={children.length > 0 ? { width: 'calc(100% - 24px)' } : undefined}
        onClick={() => {
          setIsShowChildren((prev) => !prev);
        }}
        onMouseEnter={() => {
          setHoverKey(menuOption.label)
        }}
        onMouseLeave={() => {
          setHoverKey('')
        }}
        >
        <div className={containerStyle.menuItemIconWrapper}>{ svgIcon }</div>
        <div style={{
          marginLeft: '8px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          lineHeight: '48px'}}>
          { menuOption.label }
        </div>
        {children.length > 0
          ? <div style={{ position: 'absolute', right: '10px', transform: isShowChildren ? 'rotate(-90deg)' : 'rotate(90deg)' }}>
              <Arrow />
            </div>
          : (initialState ? <div style={{position:'absolute',right:'10px'}}>
              <Arrow />
            </div> : null)
        }
    </div>;

  function isItemActive(option) {
    const { pathPrefixes } = option;
    if (option.isActive) {
      return option.isActive(pathname || '', search || '');
    }
    return pathPrefixes.some(x => (pathname || '').includes(x));
  }
  function getCollapsedSubMenuStyle(option) {
    return isItemActive(option)
      ? { color: CS_STYLES.PRIMARY_COLOR, lineHeight: '32px', display: 'block', width: '120px', textDecoration: 'none', fontWeight: 'bold'}
      : { color: '#333333', lineHeight: '32px', display: 'block', width: '120px', textDecoration: 'none'};
  }
  function getCollapsedSubMenuClass(option) {
    return isItemActive(option)
      ? `${containerStyle.collapsedSubmenuItem} ${containerStyle.collapsedSubmenuItemSelect}`
      : containerStyle.collapsedSubmenuItem;
  }
  if (showCollapsed) {
    const isPopoverVisible = isShowChildren && !!children.length;
    
    let collapsedMenuNode;
    if (children.length) {
      collapsedMenuNode = <div ref={ref} className={parentMenuClassName}
        style={{ justifyContent: 'center',display:'flex',padding:'0', marginTop: '0', marginBottom: 8}}
      >{ inner }</div>;
    } else if (disabled) {
      collapsedMenuNode = <div
        key={menuOption.label}
        className={getMenuItemClassName(menuOption)}
        style={{ justifyContent: 'center',display:'flex',padding:'0', marginTop: '0', cursor: 'not-allowed'}}
      >
        { inner }
      </div>;
    } else {
      collapsedMenuNode = <Link
        key={menuOption.label}
        className={getMenuItemClassName(menuOption)}
        to={menuOption.linkTo}
        onClick={handleScrollToTop}
        style={{ justifyContent: 'center',display:'flex',padding:'0', marginTop: '0'}}
      >
        { inner }
      </Link>;
    }

    const collapsedSubMenuNodes = children.length ?
      children.map(item => <Link
        key={item.label}
        //style={getCollapsedSubMenuStyle(item)}
        style={{textDecoration: 'none'}}
        className={getCollapsedSubMenuClass(item)}
        to={item.linkTo}
        onClick={handleScrollToTop}
      >
        <div>{item.label}</div>
      </Link>)
      : null;
    if (!children.length) {
      const tooltipTitle = disabled ? ze('没有权限', 'No Permission') : menuOption.label;
      return <Tooltip placement="right" title={tooltipTitle}>
        {collapsedMenuNode}
      </Tooltip>
    }
    // const content = children.length ? collapsedSubMenuNodes : menuOption.label;
    const content = collapsedSubMenuNodes;
    return <Popover key={menuOption.label} placement="right" content={content}
      overlayClassName={containerStyle.menuPopover}
      overlayStyle={{ position: 'fixed' }}
      onOpenChange={(isOpen) => {
        setHoverKey(isOpen ? menuOption.label : '')
      }}
    >
      {collapsedMenuNode}
    </Popover>;
  }

  // 子菜单
  const subMenuNodes = children.length ?
    children.map(item => {
      const isChildActive = isItemActive(item);
      return <Link
        key={item.label}
        className={getMenuItemClassName(item)}
        style={{ width: '100%' }}
        to={item.linkTo}
        onClick={handleScrollToTop}
      >
        <div className={containerStyle.subMenuItemWrapper} style={{ position: 'relative', width: 'calc(100% - 12px)' }}>
          {item.label}
          {isChildActive && (
            <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
              <Arrow />
            </div>
          )}
        </div>
      </Link>;
    })
  : null;
  const menuNode = children.length
    ? <div
      ref={ref}
      key={menuOption.label}
      className={parentMenuClassName}
      style={{ marginBottom: isShowChildren ? '0px' : '8px', flexDirection: 'column', alignItems: 'flex-start' }}
      >
        {inner}
        { isShowChildren && <div style={{padding: '4px 0px', width: '100%'}}>
          { subMenuNodes }
        </div>}
      </div>
    : disabled
    ? <div
      key={menuOption.label}
      className={getMenuItemClassName(menuOption)}
      style={{ cursor: 'not-allowed' }}
    >
      { inner }
    </div>
    : <Link
      key={menuOption.label}
      className={getMenuItemClassName(menuOption)}
      to={menuOption.linkTo}
      onClick={handleScrollToTop}
    >
      { inner }
    </Link>;

  if (disabled) {
    return <Tooltip title={ze('没有权限', 'No Permission')} placement='right'>
      {menuNode}
    </Tooltip>;
  }

  return <>
    {menuNode}
  </>;
}
